import React from "react"
import { Formik, FieldArray, Form } from "formik";
import Button from "storybookComponents/Button";
import { withStyles } from '@material-ui/core';
import FormContent from "./formContent"
import {
  getInitialValues,
  defaultValues
} from "./utils"
const Yup = require("yup");



const validationSchema = Yup.object().shape({
  fieldArray: Yup.array()
    .of(Yup.object().shape({
      fieldDetails: Yup.object().shape({
        fieldId: Yup.string().required('Required'),
        fieldTag: Yup.string().required('Required'),
        label: Yup.string().required('Required'),
        type: Yup.string().required('Required'),
      })
    }))
});
const styles = () => ({
  dashedButton: {
    cursor: "pointer",
    border: "1px dashed #dadada !important",
    textTransform: "capitalize",
    width: "220px",
    padding: "10px",
    textAlign: "center",
    color: "#333",
    fontFamily: "Open Sans",
    display: "block",
    marginTop: "12px !important",
    display: "flex",
    "&:hover": {
      color: "#26bbed !important",
      border: "1px dashed #26bbed !important",
    }
  },
  fieldContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: 12,
    position: "relative"
  },
  buttonStyle: {
    textTransform: "capitalize !important",
    marginTop: 20,
    width: "220px",
    display: "block",
    display: "flex"
  },
  listItemContainer: {
    display: "flex",
    alignItems: "center",
    paddingTop: 12,
    zIndex: 1500
  },
  selectContainer: {
    border: "1px solid #dadada",
    marginRight: "10px",
    height: 36,
    paddingLeft: 8,
    "&:hover": {
      border: "1px solid #26bbed"
    }
  },
  divStyle: {
    width: 19
  },
  noPointerEvents: {
    pointerEvents: "none"
  },
  positionAsterisk: {
    zIndex: 4,
    position: "absolute",
    left: 4,
    top:17
  }
})


const HylyForm = ({ classes, hylyFormFields, ...props }) => {
  const [active, setActive] = React.useState("active");
  const initialValues = getInitialValues(hylyFormFields, props.values.leadFields);
  const renderForm = ({ values, ...props }) => {
    if (Object.keys(props.errors).length === 0) {
      setActive("active")
    } else {
      setActive("inactive")
    }

    const handleReset = () => {
      props.setFieldValue("fieldArray", defaultValues)
    }
    return (
      <Form>
        <FieldArray
          name="fieldArray"
          render={arrayValues => {
            return <FormContent hylyFormFields={hylyFormFields} arrayValues={arrayValues} values={values} classes={classes} {...props} />
          }}
        />
        <Button
          type="sumbit"
          variant="primary"
          size="md"
          state={active}
          className={classes.buttonStyle}
        >
          Confirm Changes
            </Button>

        <Button
          variant="tertiary"
          size="md"
          className={classes.buttonStyle}
          onClick={handleReset}
        >
          Reset to Defaults
            </Button>
      </Form>
    )
  }

  const handleSubmit = (values) => {
    let allIds = [];
    for (let i = 0; i < values.fieldArray.length; i++) {
      let { fieldDetails, required } = values.fieldArray[i];
      if (fieldDetails.fieldId !== "hyName" && fieldDetails.fieldId !== "hyEmail" && fieldDetails.fieldId !== "hyPhone") {
        let id = fieldDetails.fieldId;
        if (required) {
          id = id + "_required"
        } else {
          id = id + "_optional"
        }
        allIds.push(id);
      }
    }
    props.onConfirmClick(allIds);
    props.toggle();
  }


  return (
    <Formik
      initialValues={{
        fieldArray: initialValues
      }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {renderForm}
    </Formik >
  )
}

export default withStyles(styles)(HylyForm)